import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Progress } from "../ui/progress";
import { Check, LoaderCircle } from "lucide-react";

interface ProgressCardProps {
    title: string;
    description?: string;
    value: number;
    total?: number;
    className?: string;
}

const ProgressCard: React.FC<ProgressCardProps> = ({ title, description, value, total = 100, className }) => {
    const percentage = Math.round((value / total) * 100);

    return (
        <Card className={className}>
            <CardHeader className="pb-0.5 pt-4">
                <CardTitle className="flex flex-row justify-between items-center">
                    <span>{title}</span>
                    {percentage < 100 ? <LoaderCircle className="w-3.5 animate-spin" /> : <Check className="w-3.5 text-green-700" />}
                </CardTitle>
            </CardHeader>
            <CardContent className="flex items-center justify-center py-2">
                <Progress value={value} progressBarIndicatorClassname={percentage >= 100 ? "bg-teal-700" : undefined}/>
            </CardContent>
            <CardFooter className="flex items-center justify-between pb-4 pt-0.5">
                <CardDescription>{description}</CardDescription>
                <div className="text-sm">{percentage}%</div>
            </CardFooter>
        </Card>
    );
};

export default ProgressCard;
